import React, { useState, useEffect } from 'react';
import './cardLawyer.scss';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useHistory } from "react-router-dom";

const starGray = '/img/icons/star-gray.svg';
const starYellow = '/img/ListLawyer/star-yellow.svg';
const fakeCalif = 0;

const useStyles = makeStyles({
    iconEmpty: {
        color: '#c1c1c1',
    },
    icon: {
        padding: '0 2px',
        '@media(max-width:768px)': {
            padding: 0,
            fontSize: 16
        }
    }
});



const NormalCard = ({ user, props }) => {
    '/img/profile/cuadro-h.svg'
    const classes = useStyles();
    const mobile = useMediaQuery('(max-width:768px)');
    const history = useHistory();
    const [videollamada, setVideollamada] = useState(false);

    const handlerPageChange = () => {
        
        history.push(`/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`, user)
        
    }

    const membership = user && user.membership;

    const tituloNombre = (auth) => {
        switch (auth.gradeStudy) {
            case 'Licenciatura': {
                return 'Lic.'
            };
            case 'Maestría': {
                if (auth.genero == 'male') {
                    return 'Mtro.'
                } else if (auth.genero == 'female') {
                    return 'Mtra.'
                }
                return null
            }
            case 'Especialidad': return 'Esp.'
            case 'Doctorado': {
                if (auth.genero == 'male') {
                    return 'Dr.'
                } else if (auth.genero == 'female') {
                    return 'Dra.'
                }
                return 'auth.gradeStudy '
            }


            default: return '';
        }
    }
    return (
        <>
        <div className="normalCard" onClick={handlerPageChange}>
            <div className="Photo">
                <div className="Photo_content">
                    <figure className="Photo_fig">
                                {mobile ?
                                    <img className="prueba-mobile" src={
                                        !user.imgProfile ? (

                                            user.role === 'lawyer' ? (
                                                !user.genero ? ('/img/avatars/avatares-cuadro-logo.svg') 
                                                : (user.genero == 'male' ? 
                                                    ('/img/avatars/avatares-cuadro-h.svg')
                                                        : ('/img/avatars/avatares-cuadro-m.svg')
                                                    )
                                            
                                            ):('/img/avatars/avatares-cuadro-logo.svg'))
                                            : 
                                            user.imgProfile
                            } alt="imagen de perfil" />
                            :
                            <img className="prueba-mobile" src={
                                !user.imgProfile ? (

                                    user.role === 'lawyer' ? (
                                        !user.genero ? ('/img/avatars/avatares-cuadro-logo.svg') 
                                        : (user.genero == 'male' ? 
                                            ('/img/avatars/avatares-cuadro-h.svg')
                                                : ('/img/avatars/avatares-cuadro-m.svg')
                                            )
                                    
                                    ):('/img/avatars/avatares-cuadro-logo.svg'))
                                    : 
                                    user.imgProfile
                            } alt="imagen de perfil" />
                        }
                    </figure>
                </div>
            </div>
            <div className="Name">
                <p style={{ marginBottom: 0 }} className="Name_text">
                    {user && user.role === 'lawyer' ? (`${tituloNombre(user)} ${user.name} ${user.firstLastName} ${user.secondLastName}`) : user.officeName}        
                </p>
            </div>
            <div className="Icons">
                {videollamada ? (<div className="Icons_content"><p className="Icons_videollamada">Videollamada</p> <img src="../img/icons/video-call.svg" alt="" /></div>) :''}
            </div>
            <div className="Ubication">
            {membership && membership.type !== 'Free' && 
                <p style={{ marginBottom: 0 }} className="Ubication_location">{user.sede ? `${user.sede[0].estado}, ${user.sede[0].municipio}` : 'Sede no definida'}
                </p>
            }
            </div>
            <div className="specialties">
                <div className="specialties_text">
                    {user.specialties.map((specialty, index) => {
                                    return (
                                        <p key={index} style={{ marginBottom: 0 }}>{specialty}</p>

                                    );
                                })}
                </div>
            </div>
            <div className="Qualification">
                   

                  
                        <div className="Qualification_stars">
                            <Rating
                                defaultValue={user.analytics && user.analytics.opinion && user.analytics.opinion.qualification ? user.analytics.opinion.qualification : 0}
                                precision={0.25}
                                size="medium"
                                classes={{ iconEmpty: classes.iconEmpty, icon: classes.icon }}
                                readOnly
                            />
                        </div>
                        <div className="Qualification_text Qualification_text--blue">

                            {user.analytics && user.analytics.opinion && user.analytics.opinion.qualification && user.analytics.opinion.qualification > 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`${user.analytics.opinion.qualification} Estrellas`}
                                </p> :
                            user.analytics.opinion.qualification && user.analytics.opinion.qualification === 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`1 Estrella`}
                                </p> :
                                <p style={{ marginBottom: 0 }}>
                                    {`0 Estrellas`}
                                </p>
                            }
                            {user.analytics.opinion.counts && user.analytics.opinion.counts > 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`${user.analytics.opinion.counts} Opiniones`}
                                </p> :
                            user.analytics.opinion.counts && user.analytics.opinion.counts === 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`1 Opinión`}
                                </p> :
                                <p style={{ marginBottom: 0 }}>
                                    {`0 Opiniones`}
                                </p>
                            }
                            
                            </div>

                           
            </div>
            <div className="Advisory">
                <div className="Advisory_text">
                    {user && user.cost && user.cost.consultingCost && <p style={{ marginBottom: 0, color: '#484848',
                        fontSize: 16, fontWeight: 'bold', fontStretch: 'normal',  fontStyle: 'normal', lineHeight: 'normal',letterSpacing: 'normal' }}>{   user.cost.consultingCost == 'yes' ? ('Primer asesoria gratuita') : 'Primer asesoria con costo'}</p>}
                    {user && user.cost && user.cost.consultingCost &&  user.cost.costRange  &&  user.cost.consultingCost == 'no' && <p style={{ marginBottom: 0 }}>{`${user.cost.costRange}`}</p>}
                </div>
            </div>
            <div
                className="BarColor"
                style={{ backgroundImage: 'linear-gradient(173deg, #cbb65e 15%, #e6d27e 30%, #8e7527 78%, #a58836 93%)' }}
            />
            <div className="Buttons">
            <button className="Buttons_buttonSec" onClick={() => {
                        const location = {
                            pathname: `/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`,
                            state: { fromPublicView: true }
                        }
                        history.push(location)
                    }}>
                        Contactar
                    </button>

                    {videollamada ? (  <button className="Buttons_button" onClick={() => {
                        const location = {
                            pathname: `/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`,
                            state: { fromPublicView: true }
                        }
                        history.push(location)
                    }}>
                        Agendar videollamada
                    </button>) : ''}
                  
            </div>
        </div>
         {/*    <section className="cardList1" onClick={handlerPageChange}>
                <div className="cardList1_sec1">

                   
                </div>
                <div className="cardList1_sec2">
                    <button className="cardList1_button" onClick={() => {
                        const location = {
                            pathname: `/${user.role === 'lawyer' ? 'abogado' : 'despacho'}/${user.uid}`,
                            state: { fromPublicView: true }
                        }
                        history.push(location)
                    }}>
                        Contactar
                    </button>
                </div>
                <div className="cardList1_sec3">

                    <p style={{ marginBottom: 0 }} className="cardList1_name">
                        {user && user.role === 'lawyer' ? (`${tituloNombre(user)} ${user.name} ${user.firstLastName} ${user.secondLastName}`) : user.officeName} 
                        {membership && membership.type === 'Premium Plus' && <span>PLUS</span>}
                    </p>
                    {membership && membership.type !== 'Free' && 
                        <p style={{ marginBottom: 0 }} className="cardList1_location">{user.sede ? `${user.sede[0].estado}, ${user.sede[0].municipio}` : 'Sede no definida'}
                        </p>
                    }
                   
                    
                </div>
               
               
                <div className="cardList1_sec4">
                {
                    
                    user && user.idLawFirm ? (<p className="title_titular" >{`Titular del despacho ${user.nameFirm}`}</p>) : ''

                }
               
                    <div className="cardList1_espe">
                        <div className="cardList1_text">
                      
                            {user.specialties.map((specialty, index) => {
                                return (
                                    <p key={index} style={{ marginBottom: 0 }}>{specialty}</p>

                                );
                            })}
                        </div>
                    </div>
                    {membership && membership.type !== 'Free' &&
                    <div className="cardList1_cali">
                        <div className="cardList1_stars">
                            <Rating
                                defaultValue={user.analytics && user.analytics.opinion && user.analytics.opinion.qualification ? user.analytics.opinion.qualification : 0}
                                precision={0.25}
                                size="medium"
                                classes={{ iconEmpty: classes.iconEmpty, icon: classes.icon }}
                                readOnly
                            />
                        </div>
                        <div className="cardList1_text cardList1_text--blue">
                            {user.analytics && user.analytics.opinion && user.analytics.opinion.qualification && user.analytics.opinion.qualification > 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`${user.analytics.opinion.qualification} Estrellas`}
                                </p> :
                            user.analytics.opinion.qualification && user.analytics.opinion.qualification === 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`1 Estrella`}
                                </p> :
                                <p style={{ marginBottom: 0 }}>
                                    {`0 Estrellas`}
                                </p>
                            }
                            {user.analytics.opinion.counts && user.analytics.opinion.counts > 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`${user.analytics.opinion.counts} Opiniones`}
                                </p> :
                            user.analytics.opinion.counts && user.analytics.opinion.counts === 1 ?
                                <p style={{ marginBottom: 0 }}>
                                    {`1 Opinión`}
                                </p> :
                                <p style={{ marginBottom: 0 }}>
                                    {`0 Opiniones`}
                                </p>
                            }
                            
                        </div>
                    </div>}
                    <div className="cardList1_costs">
                        <div className="cardList1_text">
                            {user && user.cost && user.cost.consultingCost && <p style={{ marginBottom: 0, color: '#484848',
                             fontSize: 16, fontWeight: 'bold', fontStretch: 'normal',  fontStyle: 'normal', lineHeight: 'normal',letterSpacing: 'normal' }}>{   user.cost.consultingCost == 'yes' ? ('Primer asesoria gratuita') : 'Primer asesoria con costo'}</p>}
                            {user && user.cost && user.cost.consultingCost &&  user.cost.costRange  &&  user.cost.consultingCost == 'no' && <p style={{ marginBottom: 0 }}>{`${user.cost.costRange}`}</p>}
                        </div>
                    </div>
                </div>
                <div 
                    className="cardList1_border" 
                    style={{backgroundImage: membership && membership.type === 'Premium'? 
                    'linear-gradient(87deg, #5ab7e8 0%, #b6ebff 21%, #69c1ec 63%, #5ab7e8 86%)' :  
                     membership && membership.type === 'Premium Plus'?  
                     'linear-gradient(173deg, #cbb65e 15%, #e6d27e 30%, #8e7527 78%, #a58836 93%)': 'unset'}}
                ></div>
            </section>
       */}  </>

    );
}

export default NormalCard;